import {BatteryChart} from "../../../pages/Workspace/ResultsTab/Charts/BatteryChart";
import {
    Box,
    Button, Flex, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay, Text, useColorModeValue
} from "@chakra-ui/react";
import React from "react";

const ChartModal = ({isOpen, onClose, description, label, chart}) => {
    return (
        <Modal onClose={onClose} size={"full"} isOpen={isOpen}>
            <ModalOverlay />
            <ModalContent h={"100%"} w={"100%"}>
                <ModalHeader textAlign="center">
                    <Text>{label}</Text>
                    {description}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody h={"100%"} w={"100%"}>
                    {chart}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ChartModal;